<template>
    <div class="dia_container">
        <div class="form_line cl">
            <label class="l">资源名称：</label>
            <div class="l inpt"><el-input v-model="resource.resourcename"></el-input></div>
        </div>
        <div class="form_line cl">
            <label class="l">资源KEY：</label>
            <div class="l inpt"><el-input v-model="resource.resourcekey"></el-input></div>
        </div>
        <div class="form_line cl">
            <label class="l">资源类别：</label>
            <div class="l inpt">
                <el-select v-model="resource.resourcetype">
                    <el-option label="服务资源" value="0"></el-option>
                    <el-option label="客户端使用资源" value="1"></el-option>
                    <el-option label="服务端使用资源" value="2"></el-option>
                </el-select>
            </div>
        </div>
        <div class="dia_btn_container">
            <el-button @click="cancel">取消</el-button>
            <el-button type="primary" @click="save">保存</el-button>
        </div>
    </div>
</template>
<script>
    import {errorMessage} from '../../util'
    export default {
        props: ['config'],
        data: function(){
            return {
                resource: {
                    resourcegroupid: '',
                    resourceid: '',
                    resourcekey: '',
                    resourcename: '',
                    resourcetype: ''
                }
            }
        },
        created: function(){
            this.updateResource(this.config)
        },
        methods: {
            cancel(){
                this.$emit('cancel')
            },
            save(){
                let url = this.resource.resourceid ? '/resourceconfig/resource/update' : '/resourceconfig/resource/add'
                this.$http.post(url,{
                    resourcekey: this.resource.resourcekey,
                    resourcename: this.resource.resourcename,
                    resourcegroupid: this.resource.resourcegroupid,
                    resourcetype: this.resource.resourcetype,
                    resourceid: this.resource.resourceid
                }).then(function(res){
                    this.$message.success('保存成功！')
                    this.cancel()
                    this.$emit('refresh')
                }).catch(error => {
                    errorMessage(error, this)
                })
            },
            updateResource(data){
                for(let i in this.resource) {
                    this.resource[i] = data[i] ? data[i] : ''
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resourceEdit.vue?60c2062d